import { useMutation, useQueryClient } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import {
  contractingKeys,
  dashboardKeys,
  interestKeys,
} from "@/lib/query-keys";
import { capture } from "@/lib/posthog";

export interface InterestInput {
  keyword: string;
  /**
   * Obligatorio a propósito: el backend borra y recrea en cada guardado, así que
   * un payload sin `active` reactiva en silencio lo que el usuario había apagado.
   * Que sea requerido obliga a cada caller a decidirlo.
   */
  active: boolean;
  priceitemcategory_id: number | null;
}

export function useUpdateInterests() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: {
      interests: InterestInput[];
      searchProfileId?: number;
      // El wizard guarda con la pantalla de fondo a la vista: refrescarla a
      // mitad se ve como si la app se moviera sola. Refresca él al terminar.
      deferRefresh?: boolean;
    }) =>
      fetchToBackend<{ success: boolean }>(
        "/userpriceiteminterests/updateAll",
        {
          method: "POST",
          body: JSON.stringify({
            interests: vars.interests,
            ...(vars.searchProfileId
              ? { searchProfileId: vars.searchProfileId }
              : {}),
          }),
        },
      ),
    onSuccess: (_d, vars) => {
      capture("interests_updated", { count: vars.interests.length });
      if (vars.deferRefresh) return;
      qc.invalidateQueries({
        queryKey: interestKeys.byProfile(vars.searchProfileId),
      });
      qc.invalidateQueries({ queryKey: contractingKeys.lists() });
      qc.invalidateQueries({ queryKey: dashboardKeys.all });
    },
  });
}
